import { ThemeProvider } from '@ori-ui/mui';
import { PrefetchedTokenProvider } from '@ori/auth';
import ReactDOM from 'react-dom';

import { ErrorBoundary, TopAreaApp } from './containers';
import { getAppConfiguration, getToken } from './utils';
import { trackCustomerTokenMismatch } from './utils/customerTokenMismatchCheck';
import { extractTokenFromUrl } from './utils/extractTokenFromUrl';
import 'core-js/proposals/relative-indexing-method';
import './App.css';

/**
 * React app renderer that is used when app is used as a standalone SPA
 */
export const render = async (): Promise<void> => {
  const rootEl = document.getElementById('online-top-area-root');

  if (rootEl) {
    const { config = '' } = rootEl.dataset;
    const appConfig = getAppConfiguration(config);
    const { customerId, tenant, identityUrl: dirtyIdentityUrl } = appConfig;
    const identityUrl = dirtyIdentityUrl.endsWith('/')
      ? dirtyIdentityUrl.slice(0, -1)
      : dirtyIdentityUrl;

    await extractTokenFromUrl(identityUrl);

    const token = await getToken({ customerId, tenant, identityUrl });

    try {
      trackCustomerTokenMismatch(customerId, token);
    } catch (error: unknown) {
      console.warn(error);
    }

    ReactDOM.render(
      <ErrorBoundary>
        <PrefetchedTokenProvider
          customerId={customerId}
          token={token.toString()}
        >
          <ThemeProvider
            enableCacheProvider
            cacheKey="top-area"
          >
            <TopAreaApp {...appConfig} />
          </ThemeProvider>
        </PrefetchedTokenProvider>
      </ErrorBoundary>,
      rootEl,
    );
  }
};
